import React, { Suspense } from 'react';

import { Outlet } from 'react-router-dom';

import { AuthProvider } from '@/providers/Auth.provider';

import { GlobalBg } from '@/components/Layout/GlobalBg';

import { LocalStorageProvider } from '@/contexts/localStorage.context';
import { SidebarContextProvider } from '@/contexts/sidebar.context';

import { PageLoader } from '@/elements/PageLoader';

const AppLayout: React.FC = () => {
  return (
    <LocalStorageProvider>
      <SidebarContextProvider>
        <GlobalBg>
          <AuthProvider>
            <Suspense fallback={<PageLoader />}>
              <Outlet />
            </Suspense>
          </AuthProvider>
        </GlobalBg>
      </SidebarContextProvider>
    </LocalStorageProvider>
  );
};

export default AppLayout;
